module.exports = __webpack_public_path__ + "static/media/model-table-icon.40ef817b.svg";